module.exports = __webpack_public_path__ + "static/media/startcareer.c4b36c06.png";